import React, { useState } from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import { useTranslation } from 'react-i18next'
import { MicIcon, SendIcon } from './icons'
import styles from './index.module.scss'

interface ComposerProps {
  onSend: (text: string) => void
  /** a turn is in flight — block sending (typing stays allowed) */
  busy: boolean
}

const Composer: React.FC<ComposerProps> = ({ onSend, busy }) => {
  const { t } = useTranslation()
  const [value, setValue] = useState('')

  const submit = () => {
    const text = value.trim()
    if (!text || busy) return
    onSend(text)
    setValue('')
  }

  const onKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    // Enter sends; Shift+Enter inserts a newline. Ignore Enter mid-IME
    // composition so composing languages don't send half a word.
    if (e.key === 'Enter' && !e.shiftKey && !e.nativeEvent.isComposing) {
      e.preventDefault()
      submit()
    }
  }

  return (
    <div className={styles.composer}>
      <div className={styles.field}>
        {/* voice channel is visual-only for v1 — present, not yet wired */}
        <button
          type="button"
          className={styles.voiceBtn}
          title={t('genAI.copilot-voice-cta')}
          aria-label={t('genAI.copilot-voice-cta')}>
          <MicIcon />
        </button>
        <TextareaAutosize
          className={styles.input}
          value={value}
          minRows={1}
          maxRows={5}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder={t('genAI.copilot-placeholder')}
          aria-label={t('genAI.copilot-placeholder')}
          autoComplete="off"
        />
        <button
          type="button"
          className={styles.sendBtn}
          onClick={submit}
          disabled={busy || !value.trim()}
          aria-label={t('genAI.copilot-send')}>
          <SendIcon />
        </button>
      </div>
      <div className={styles.hint}>{t('genAI.copilot-disclaimer')}</div>
    </div>
  )
}

export default Composer
